// extracted by mini-css-extract-plugin
export default {"homePageContainer":"HomePageStyles_homePageContainer__bQQZe"};